<a (click)="toggle()">
  @if (!value) {
    {{'app-enable' | translate}}
  }
  @if (value) {
    {{'app-disable' | translate}}
  }
</a>
